import React from "react";
import { Redirect } from "react-router-dom";
import SubscriptionRestrictedFeature from "../../common/SubscriptionRestrictedFeature";
import { getPayrollRoleId, isPayrollAdmin } from "./payrollAccessUtils";

/**
 * Restricts payroll routes to admins (role 1 / 2).
 * @param {{ children: React.ReactNode }} props
 */
const PayrollAdminShell = ({ children }) => {
  const rid = getPayrollRoleId();
  if (!isPayrollAdmin(rid)) {
    return <Redirect to="/dashboard" />;
  }
  return (
    <SubscriptionRestrictedFeature actionKey="app.subscriptionRestriction.actionAccessPayroll">
      {children}
    </SubscriptionRestrictedFeature>
  );
};

export default PayrollAdminShell;
